module.exports = __webpack_public_path__ + "media/reception.7301f2f3.mp3";